import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { css } from "@emotion/react";

import { ImageAspectRatio } from "../_shared-components/image-related/AspectRatio";
import { SwarovskiGenericCarouselComponent } from "../_shared-components/ui-elements/SwarovskiGenericCarouselComponent/SwarovskiGenericCarouselComponent";
import { ImageCarouselComponentHeadline } from "../_shared-components/ui-elements/SwarovskiGenericCarouselComponent/ImageCarouselComponentHeadline";
import { ImageCarouselType } from "@swo/storefront";
import { getComponentCMSClassname, getComponentHookClass } from "../cms/edit-overlay/component-hook-class";

export function ImageCarouselComponent(props: ImageCarouselType & { width: "full" | "content"; scrollSnap: boolean }) {
  const imageAttachStyles = css`
    width: 100%;
    height: 100%;

    position: relative;
    display: inline-block;

    img {
      padding-left: 1.5px;
      padding-right: 1.5px;
    }
  `;

  const imageWidth = 1400 / 5;

  const carouselElementsMemo = useMemo(() => {
    return props.imagesCollection.map((image, idx) => {
      return (
        <ImageAspectRatio
          assetId={image.sys.id}
          key={idx}
          aspectRatio={{
            width: 16,
            height: 10,
            attachStyles: imageAttachStyles,
          }}
          contentfulLink={{
            url: image.url,
            requestedWidth: imageWidth,
            noTransparentBackground: true,
          }}
          alt={image.description || image.title}
        />
      );
    });
  }, [props.imagesCollection]);

  return (
    <SwarovskiGenericCarouselComponent
      className={getComponentCMSClassname(props?.sys?.id)}
      width={props.width}
      headline={
        props.headline && (
          <ImageCarouselComponentHeadline className={"left"}>{props.headline}</ImageCarouselComponentHeadline>
        )
      }
      scrollSnap={props.scrollSnap}
      bottomText={props.author || undefined}
      carouselElements={carouselElementsMemo}
      imageWidth={imageWidth}
    />
  );
}
